import { GuideOrb, type GuideOrbVariant } from '@/components/ui/GuideOrb';

export interface AgentThinkingIndicatorProps { label?: string; size?: number; className?: string; variant?: GuideOrbVariant; }
export function AgentThinkingIndicator({ label, size = 16, className, variant = 'orb' }: AgentThinkingIndicatorProps) {
  return <span className={`inline-flex shrink-0 items-center justify-center ${className || ''}`} style={{width:size,height:size}}
    role={label ? 'status' : undefined} aria-label={label} aria-hidden={label ? undefined : true} data-agent-thinking-indicator="true">
    <GuideOrb size={size} variant={variant} />
  </span>;
}
